export default __webpack_public_path__ + "static/media/bg-featured-video.2f3620ba.png";